import React from 'react';

import RecordsGrid from 'components/Grid/RecordsGrid';
import Report from 'components/Report';
import MetricPopup from 'screens/DataManager/Metrics/MetricPopup';

import { InjectedComponentsContext } from './context';

const INJECTED_COMPONENTS = {
  MetricPopup,
  RecordsGrid,
  Report,
};

const InjectedComponentsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <InjectedComponentsContext.Provider value={INJECTED_COMPONENTS}>
    {children}
  </InjectedComponentsContext.Provider>
);

export default InjectedComponentsProvider;
